import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { BranchService } from "../../model/branch";
import * as XLSX from "xlsx";
import TailSpin from "react-loading-icons/dist/esm/components/tail-spin";
import { StudyReportService } from "../../model/study-report";
import Loading from "../../components/Loading";
import UserRule from "../base-forms/basicdata/UserRule";

const MenuReport = {
  BranchReport: 1,
  RadiotimeReport: 2,
};

export default function ExportExcel() {
  const userDetail = useSelector((state) => state.user.detail);
  const userInfo = useSelector((state) => state.user);

  const [dateValue, changeDateRange] = useState([new Date(), new Date()]);
  const [selected, setSelected] = useState([]);
  const [branch, setBranch] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const dispatch = useDispatch();

  // LOAD PAGE FIRST TIME
  useEffect(() => {
    loadBranchs();
    setSelected([]);
    return () => {
      setSelected([]);
    };
  }, []);

  // LOAD BRANCH LIST
  const loadBranchs = async () => {
    setLoading(true);
    let ret = await BranchService.GetList({ UserInfo: userDetail });

    if (ret) {
      setBranch(ret);
    }
    setLoading(false);
  };

  useEffect(() => {
    console.log(selected);
  }, [selected]);
  // SELECT BRANCH
  const onselected = (e) => {
    let selBranch = Number(e.target.value);
    if (e.target.checked) {
      setSelected((p) => [...p, selBranch]);
    } else {
      setSelected((p) => p.filter((item) => item !== Number(selBranch)));
    }
  };

  // EXPORT TO EXCEL
  const toExcel = async () => {
    const setLoadState = (value) =>
      new Promise((resolve, reject) => {
        setBtnLoading(value);
        resolve(true);
      });

    const exportExcel = (data, filename) =>
      new Promise((resolve, reject) => {
        let wb = XLSX.utils.book_new(),
          ws = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, filename + ".xlsx");
        resolve(true);
      });

    await setLoadState(true);
    let data = await StudyReportService.GetList({
      Branchs: selected,
      DateRange: dateValue,
    });

    let fname = "";
    selected.map((item, i) => {
      branch.map((b, j) => {
        if (b.brchid == item) {
          fname += b.brchname + "-";
        }
      });
    });

    // สร้างชื่อไฟล์ Excel
    fname +=
      dateValue[0].toLocaleDateString("th") +
      "to" +
      dateValue[1].toLocaleDateString("th");
    fname = fname.replace("รพ.", "");

    fname = fname.replace(".", "_");

    // RENDER EXCEL

    if (data != null) {
      let ret = await exportExcel(data, fname);
    } else {
      // dispatch(setReminder)
    }
    setBtnLoading(false);
  };

  const menuList = [
    { label: "รายงานการอ่านผล", value: 1 },
    { label: "รายงานเวลาการอ่านผลคนไข้", value: 2 },
  ];

  const [selectedMenu, setSelectedMenu] = useState(1);
  const selectMenu = (value) => {
    setSelectedMenu(value);
  };

  return (
    <MainDiv>
      <ContainerBox>
        <SubDiv>ประเภทรายงาน</SubDiv>
        <VBox style={{ paddingLeft: "20px" }}>
          {menuList.map((item) => {
            console.log(item.value);
            return (
              <Form.Check
                label={item.label}
                radioGroup="1"
                type="radio"
                value={item.value}
                checked={selectedMenu == item.value}
                onChange={(e) => selectMenu(e.target.value)}
              />
            );
          })}
        </VBox>
        <HorLine />
        <SubDiv>ระหว่าง</SubDiv>
        <SubDiv style={{ paddingLeft: "20px" }}>
          <DateRangePicker
            onChange={changeDateRange}
            value={dateValue}
            format="dd/MM/yyyy"
            locale="th-Th"
            closeCalendar={false}
            clearIcon={null}
          />
        </SubDiv>

        {/* BRANCH SELECTOR */}
        {selectedMenu == MenuReport.BranchReport ? (
          <VBox>
            <HorLine />
            <SubDiv>ระบุสาขา</SubDiv>

            <VBox style={{ paddingLeft: "20px" }}>
              {branch.map((item, i) => {
                if (
                  userInfo?.userRule?.flag_admin == "y" ||
                  userDetail?.brchid == item.brchid
                ) {
                  return (
                    <Form.Check
                      label={item.brchname}
                      name={item.brchname}
                      value={item.brchid}
                      onChange={onselected}
                    />
                  );
                }
              })}
            </VBox>
          </VBox>
        ) : (
          <></>
        )}
        {/* BUTTON CLICE EXPORT */}
        <SubDivButton>
          <Button onClick={() => toExcel()}>
            Export to Excel
            {btnLoading ? <TailSpin /> : <></>}
          </Button>
        </SubDivButton>
      </ContainerBox>
      {isLoading ? <Loading /> : <></>}
    </MainDiv>
  );
}

const MainDiv = styled.div`
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  color: #8b6767;
  border: 1px solid #444141;
  padding-block: 20px;
  padding-inline: 50px;
  border-radius: 5px;
`;

const SubDiv = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--fore-primary);
  margin-block: 0px;
  padding-block: 2px;
`;

const VBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  color: var(--select-item-color);
  margin-block: 0px;
  padding-block: 2px;
`;

const SubDivButton = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: end;
  margin-top: 50px;
  width: 300px;
`;

const HorLine = styled.hr`
  height: 2px;
  width: 100%;
  color: var(--border-color);
`;
